export const APP_TITLE = `${(process.env.APP_TENANT || 'gg').toUpperCase()} Management`
